module.exports = __webpack_public_path__ + "img/virtual_cabinet.2df5b4f5.svg";